<template>     
  <span v-if="business">
     <header   class="w3-top w3-bar w3-theme w3-hide-large" style="height:60px">
      <large-button @click="click('opensidebar')">&#9776;</large-button> {{business.name}}:{{business.declineorders}}      
      <h3  class="w3-bar-item w3-display-topmiddle">        
        
        <span v-if="business.hidehelp" class="w3-button w3-large w3-circle w3-hover-theme">            
            <label v-if="routetitle">{{routetitle}}</label>            
        </span> 

        <span v-if="!business.hidehelp" @click="click('openhelppage')" class="w3-button w3-large w3-circle w3-hover-theme">            
            <label v-if="routetitle">{{routetitle}}</label>
            <i class="fa fa-question-circle"></i>
        </span> 
        
      </h3>      
    
    </header>

    <header class="w3-bar w3-display-container w3-theme w3-hide-small w3-hide-medium large-header-top">    
      
      <span class="w3-bar-item w3-display-topleft">
        <span class="header-shop-name">{{business.name}}</span>       
      </span>      

      <h3 class="w3-bar-item w3-display-topmiddle">      
                      
                     
            <span v-if="business.hidehelp" class="w3-button w3-large w3-circle w3-hover-theme">            
                        <label v-if="routetitle">{{routetitle}}</label>            
                    </span> 

                    <span v-if="!business.hidehelp" @click="click('openhelppage')" class="w3-button w3-large w3-circle w3-hover-theme">            
                        <label v-if="routetitle">{{routetitle}}</label>
                        <i class="fa fa-question-circle"></i>
                    </span> 
      </h3>
      
      <span class="w3-display-bottomleft">     

        <router-link v-if="adminrights" class="w3-bar-item" to="/admin/customerremedials/processing">Remedials</router-link> 

        <div class="w3-dropdown-hover">
          <span class="w3-bar-item">
            Home <i class="fa fa-caret-down"></i>
          </span>
          <div class="w3-dropdown-content w3-bar-block w3-theme-action">
              <router-link v-if="business.pwa" class="w3-bar-item" to="/">{{business.pwa.menus.home}}</router-link>
              <router-link v-if="business.pwa" class="w3-bar-item" to="/about">{{business.pwa.menus.about}}</router-link> 
              <router-link v-if="sysadmin || (alladminrights && Object.keys(alladminrights).length>=1)" class="w3-bar-item" to="/businessselect">My Businesses</router-link>                
          </div>          
        </div>        
        
        
        

        <div v-if="adminrights && (adminrights.read || adminrights.write)" class="w3-dropdown-hover">
          <span class="w3-bar-item">
            Administration <i class="fa fa-caret-down"></i>
          </span>
          <div class="w3-dropdown-content w3-bar-block w3-theme-action">    

            <router-link class="w3-bar-item w3-button" to="/admin/common">Common Configuration</router-link>         
   
            <router-link class="w3-bar-item w3-button" to="/admin/businesslinks">Links</router-link>
            <router-link class="w3-bar-item w3-button" to="/admin/staff">Staff</router-link>

            <router-link v-if="adminrights && adminrights.custorderprocess" class="w3-bar-item w3-button" to="/admin/customerorders/home">Cust Orders</router-link> 
            
            
          </div>
        </div>

        <div class="w3-dropdown-hover">
          <span class="w3-bar-item">
            Help <i class="fa fa-caret-down"></i>
          </span>
          <div class="w3-dropdown-content w3-bar-block w3-theme-action">
              <router-link v-if="business && !business.hidehelp" class="w3-bar-item w3-button" to="/how">How To</router-link> 
              <router-link class="w3-bar-item w3-button" to="/wpp">Privacy</router-link>
              <router-link class="w3-bar-item w3-button" to="/termsconditions">Terms</router-link>
              <a href="#" class="w3-bar-item w3-button" @click="click('unregister')">Refresh</a>
              
          </div>
        </div>
      </span>  
      
      <span class="w3-display-bottomright">
          <router-link v-if="!person" class="w3-bar-item w3-button" to="/login">Login</router-link>
            
          
         <div  class="w3-dropdown-hover">   
          <span v-if="person" class="w3-bar-item w3-button">
            {{person.displayName || 'Profile'}} <i class="fa fa-caret-down"></i>
          </span>        
          <div v-if="person" class="w3-dropdown-content w3-bar-block w3-theme-action">    
            <router-link v-if="profile" class="w3-bar-item w3-button" to="/profile">Profile</router-link>                             
            <a href="#" class="w3-bar-item w3-button" @click="click('logout');$router.push('home')">Logout</a>         
          </div>
        </div>
        
      </span>
      

     
    </header>

    


  </span>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from "vuex";
export default {    
  
  data: function() {
      return {}
  },
  methods: {
    click(action){
       this.$emit("click", {
          action: action
      });      
    }
  },      
  computed: {      
    ...mapGetters(["business", "person", ,"adminrights",
    "alladminrights","profile","routetitle","sysadmin"])
  }
};
</script>
 
<style>
   .fa-shopping-cart{
     height: 10px
   }
   .large-header-top{
        top: 0;
        position: fixed;
        width: 100%;
        z-index: 5;
        height:100px;
        overflow:visible
   }
   .header-shop-name{
     font-family: Segoe UI,Arial,sans-serif;
    font-weight: 400;
    margin: 10px 0;
        font-size: 30px;
   }

</style>



// WEBPACK FOOTER //
// src/components/app/HeaderLayout.vue